import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative pt-12 pb-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto text-center" data-id="element-50">
      <div className="space-y-8 mx-auto" data-id="element-51">
        <p className="text-muted text-sm font-bold tracking-widest uppercase" data-id="element-52">
          Melbourne, Australia • Since 2011
        </p>

        <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif font-semibold text-text leading-tight max-w-4xl mx-auto" data-id="element-53">
          eCommerce experts since 2011.
        </h1>

        <p className="text-xl md:text-2xl text-muted max-w-2xl mx-auto font-light" data-id="element-54">
          Agency services and software from a team that's seen it all.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-4 max-w-[calc(100%-0px)] mx-auto" data-id="element-55">
          <div className="flex justify-center md:justify-end" data-id="element-56">
            <Link to="/modern-commerce" data-id="element-57">
              <Button size="lg" data-id="element-58">Modern Commerce</Button>
            </Link>
          </div>
          <div className="flex justify-center md:justify-start" data-id="element-59">
            <Link to="/apps-division" data-id="element-60">
              <Button variant="outline" size="lg" data-id="element-61">
                Apps Division
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}